import { render, staticRenderFns } from "./table-multi-level-column.vue?vue&type=template&id=63019a55&scoped=true&"
import script from "./table-multi-level-column.vue?vue&type=script&lang=js&"
export * from "./table-multi-level-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63019a55",
  null
  
)

export default component.exports